// Firebase configuration for Spa~Radise Luxe Admin Site
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const analytics = getAnalytics(app);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

// Firestore collections
export const COLLECTIONS = {
  MANUAL_PAYMENTS: 'manualPayments',
  SERVICES: 'services',
  COMBO_PACKAGES: 'comboPackages',
  BOOKINGS: 'bookings',
  CUSTOMERS: 'customers',
  ADMIN_USERS: 'adminUsers',
  SETTINGS: 'settings',
  REVIEWS: 'reviews',
  GIFT_CARDS: 'giftCards',
  GALLERY: 'gallery',
  BLOG_POSTS: 'blogPosts',
  VIDEO_GUIDES: 'videoGuides'
};

// Storage paths
export const STORAGE_PATHS = {
  SERVICE_IMAGES: 'service-images',
  PROFILE_IMAGES: 'profile-images',
  DOCUMENTS: 'documents',
  GALLERY: 'gallery',
  BLOG: 'blog'
};

export { app, analytics, db, storage, auth };
export default app;
